import React, { useCallback, useState } from 'react';

import { Modal, Button } from '../..';
import { UBER_TEXT } from '../../../constants/constants';

import styles from './index.module.css';

export const useRedeemFlexibleRideModal = ({ id, onConfirm, loading }) => {
  const [visibleModal, setModalVisible] = useState(false);

  const onCancel = useCallback(() => setModalVisible(false), []);

  const handleConfirm = useCallback(async () => {
    try {
      await onConfirm();
      setModalVisible(false);
    } catch {
      setModalVisible(false);
    }
  }, [onConfirm]);

  return {
    Modal: (
      <Modal
        visible={visibleModal}
        onCancel={onCancel}
        closable
        width={720}
        myClassName={styles.redeemModal}
        title={
          <div className={styles.modalTitle}>
            <div>{UBER_TEXT.REDEEM_RIDE_CONFIRM_TITLE}</div>
            <div className={styles.modalRideId}>
              ID <span className={styles.modalRideIdValue}>{id}</span>
            </div>
          </div>
        }
      >
        <div className={styles.modalContent}>
          <p className={styles.modalPrimaryText}>
            {UBER_TEXT.REDEEM_RIDE_CONFIRM_PRIMARY}
          </p>
          <p className={styles.modalQuestionText}>
            {UBER_TEXT.REDEEM_RIDE_CONFIRM_QUESTION}
          </p>
          <div className={styles.modalBtns}>
            <div>
              <Button myClassName={styles.navigationBtn} onClick={onCancel} disabled={loading}>
                No
              </Button>
            </div>
            <div>
              <Button
                myClassName={styles.navigationBtn}
                onClick={handleConfirm}
                disabled={loading}
                loading={loading}
              >
                Yes
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    ),
    setRedeemModalVisible: setModalVisible,
  };
};
